// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Global fetch timeout to prevent 90s hangs on lie-fi.
// Storage uploads/downloads are excluded (can legitimately take long).
const DEFAULT_TIMEOUT_MS = 8_000;
const originalFetch: typeof fetch =
  typeof window !== 'undefined' ? window.fetch.bind(window) : fetch;

const timedFetch: typeof fetch = (input, init = {}) => {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.toString()
        : (input as Request).url;

  // Skip timeout for storage operations (uploads/downloads can be slow)
  const isStorage = url.includes('/storage/v1/object');
  if (isStorage) {
    return originalFetch(input as RequestInfo, init);
  }

  const ctrl = new AbortController();
  const existing = (init as RequestInit).signal;
  if (existing) {
    if (existing.aborted) ctrl.abort();
    else existing.addEventListener('abort', () => ctrl.abort(), { once: true });
  }
  const timer = setTimeout(() => ctrl.abort(), DEFAULT_TIMEOUT_MS);
  return originalFetch(input as RequestInfo, { ...init, signal: ctrl.signal }).finally(
    () => clearTimeout(timer),
  );
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: timedFetch,
  },
});